export default "__VITE_ASSET__qBR3b01r__"